let scroll = window.requestAnimationFrame

const elementsToShow = document.querySelectorAll( '.animate' )
const animationActionClass = 'animated'

let scrollPositionY = 0
let utilityEnableTimeout = null


const init = function() {

    if ( window.requestAnimationFrame ) {
        loop()
    } else {
        showAllAnimationElements()
    }

}


const loop = function() {
    watchForAnimationElements()
    watchTop()
    scroll( loop )
}


const watchTop = function() {

    // get current scroll position
    const scrollAmount = window.scrollY

    // if it hasn't changed since last scroll, bail now
    if ( scrollPositionY === scrollAmount ) return

    // otherwise, update the main scroll tracking variable
    scrollPositionY = scrollAmount

    clearTimeout( utilityEnableTimeout )

    if ( scrollAmount <= 0 ) {
        document.body.classList.remove('disable-utilities')
        utilityEnableTimeout = setTimeout( () => document.body.classList.add('is-at-top'), 5 )
    } else if ( scrollAmount > 0 ) {
        document.body.classList.remove('is-at-top')
        document.body.classList.add('disable-utilities')
    }

}



const watchForAnimationElements = function() {
    elementsToShow.forEach( ( element ) => {
        if ( isElementInViewport( element ) ) {
            if ( element.classList.contains( animationActionClass ) ) return
            element.classList.add( animationActionClass )
        }
    } )
}


const isElementInViewport = function( element ) {

    const rect = element.getBoundingClientRect()

    return (
        ( rect.top <= 0 && rect.bottom >= 0 )
        ||
        ( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
        ||
        ( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
    )

}


const showAllAnimationElements = function() {

    elementsToShow.forEach( element => { element.classList.add( animationActionClass ) } )

}


const api = {
    init: init
}

export default api;
